function normalizeStageTypeKey(value) {
  return String(value || '').trim().toLowerCase()
}

export function buildStageTypeFilterOptions(stageTypes) {
  const options = []
  const seen = new Set()

  ;(stageTypes || []).forEach((stageType) => {
    const rawLabel = stageType?.name ?? stageType?.label ?? stageType?.code ?? stageType?.id
    const label = String(rawLabel || '').trim()
    if (!label) return

    const key = normalizeStageTypeKey(label)
    if (seen.has(key)) return
    seen.add(key)

    const value = String(stageType?.id ?? stageType?.value ?? label)
    options.push({
      value,
      label,
      searchText: [label, stageType?.code, stageType?.id].filter(Boolean).join(' '),
    })
  })

  return options
}
